import { render, staticRenderFns } from "./NutritionCard.vue?vue&type=template&id=734ccade&"
import script from "./NutritionCard.vue?vue&type=script&lang=js&"
export * from "./NutritionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports